import { NgModule } from '@angular/core';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-cadastro-validar',
  templateUrl: './cadastro-validar.component.html',
  styleUrls: ['./cadastro-validar.component.css']
})
export class CadastroValidarComponent implements OnInit {
  @ViewChild("uploader") meuUploader: ElementRef;
  @ViewChild("codigoInput") codigoInput: ElementRef;
  @ViewChild("codigoInput1") codigoInput1: ElementRef;
  hideLoginLoad: boolean = false;
  resend_hide: boolean = true;
  codigoact: any = '';
  codigoact2: any = '';
  uidCliente: any = '';
  etapa: any = 0;
  someKey: any = '';
  listaCidades: any[] = [];
  listaUF: any[] = [];
  ufSelecionado: any = '';
  showDDC: any = false;
  myControl = new FormControl();
  myControl2 = new FormControl();
  filteredOptions: Observable<string[]>;
  filteredOptions2: Observable<string[]>;
  ufSelecionadoN: any = '';
  cidadeSelecionadaN: any = '';
  isPassword: boolean = true;
  senha: any = '';
  meuEmail: any = '';
  nomeArquivo: any = '';
  imageChangedEvent: any = '';
  croppedImage: any = '';
  arrFotos: any[] = [];
  urlFoto: any = '';
  fotoPerfil: any = '';
  fotodepois: boolean = false;
  nickUsuario: any = '';
  qTema: any = '';
  altura: any = '';
  peso: any = '';
  nivelatividade: any = '';
  fulano: any = '';
  canvasRotation: any = 0;
  public maskCodigo = [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/,];

  constructor(public tmaService: TamasAlunoService, private route: ActivatedRoute, public router: Router, public dialog: MatDialog, private _location: Location) {

    route.params.subscribe(val => {
      this.tmaService.eventoFS(false);
      this.funcaoInicial();
    })
  }

  ngOnInit() {


  }

  funcaoInicial(): void {
    this.hideLoginLoad = true
    this.uidCliente = this.route.snapshot.paramMap.get('idcadastrado');
    this.etapa = this.route.snapshot.paramMap.get('etapa');

    this.someKey = this.route.snapshot.paramMap.get('parametroextra');
    console.log(this.someKey);
    this.checarEtapa();

    this.tmaService.getJsonBR("")
      .subscribe((qRes) => {
        console.log(qRes);
        this.hideLoginLoad = true;
        this.listaUF = qRes['estados'];
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      })


    setTimeout(() => {
      this.resend_hide = false;
    }, 15000);
  }
  togglePW(): void {
    this.isPassword = !this.isPassword;
    console.log(this.isPassword);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaUF.filter(option => option.id.toLowerCase().includes(filterValue));
  }

  private _filter2(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaCidades.filter(option => option.cidade.toLowerCase().includes(filterValue));
  }

  digitando(textoBusca: any): void {

  }

  changeUFn(siglaUF: any): void {
    this.hideLoginLoad = false;
    this.showDDC = true;
    console.log("foi");
    this.tmaService.getJsonUF(siglaUF)
      .subscribe((qRes) => {
        console.log(qRes);
        this.listaCidades = qRes['cidades'];

        this.cidadeSelecionadaN = '';

        this.filteredOptions2 = this.myControl2.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter2(value))
          );
        this.hideLoginLoad = true;
      })
  }


  checarEtapa(): void {
    //cada etapa pode exigir um procedimento ou não

    if (this.etapa == 1) {
      //consultar no servidor a key
      //se for true, exibe boas vindas
      //pede q usuario crie uma senha e depois disso pulamos para etapa 3

      if (this.tmaService.hcEmail == '') {
        //veio pelo link direto, consultar no servidor
        //porem pode ter atualizado a página, verificar se for null, redirecionar pro login
        
        if(this.someKey == 'null'){
          this.voltar();
          return;
        }
        this.hideLoginLoad = false;
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          idaluno: this.uidCliente,
          codigoextra: this.someKey
        };
        this.tmaService.welcomePreUser(customParams)
          .subscribe((qRes) => {
            this.hideLoginLoad = true;
            if (qRes['res'] == 'done') {
              this.meuEmail = qRes['email'];
              this.fulano = qRes['nomeAluno'];
            }
            else {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "E-mail não cadastrado, verifique se digitou corretamente.", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
      }

    }
    else if (this.etapa == 2) {
      //validar o código (insere e clica em ok)
      //se retorno true, redirecionamos para etapa 3

    }
    else if (this.etapa == 3) {
      //cidade e uf

    }
    else if (this.etapa === 4) {
      //peso e altura (informar q isso pode ser alterado depois)
      //e nivel de praticante de atividade física (amador, sei lá quais são)
    }
    else if (this.etapa == 5) {
      //foto do perfil - informar demais fotos indo no perfil e etc
    }
    else if (this.etapa == 6) {
      //escolher nick, facilidade para compartilhar e encontrar amigos

    }
    else if (this.etapa == 7) {
      //escolha do tema, light ou dark
      //após o retorno redirecionamos para a home = ETAPAS CONCLUÍDAS


    }




  }

  concluirMissao(): void {

    if (this.etapa == 1) {
      if(this.someKey == 'null'){
        if (this.codigoact2 == '') {
          const codnotnull = this.dialog.open(AlertaSimplesDialog, {
            data: { textoAlerta: "Por favor digite o código para continuar" }
          });
          return;
        }
      }

      if (this.senha.length < 6) {
        const senhaInsuf = this.dialog.open(AlertaSimplesDialog, {
          data: { textoAlerta: "Sua senha deve ter pelo menos 6 digitos" }
        });
        return;
      }
      //server side
      let customParams = {
        idaluno: this.uidCliente,
        codigoextra: this.someKey,
        codigoatv: this.codigoact2,
        senha: this.senha,
        email: this.meuEmail,
      };

      this.hideLoginLoad = false;
      this.tmaService.confirmarCodigoByEmail(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'done') {
          // this.router.navigate(['/dashboard/paciente/' + qRes['novoID']]);
          this.tmaService.logado = true;
          if (this.tmaService.hcEmail == '') {
            this.tmaService.hcEmail = this.meuEmail;
          }
          this.tmaService.hcSenha = this.senha;
          //go proxima etapa
          this.router.navigate(['/meu-cadastro/s/3/' + this.uidCliente + '/0']);
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
          });
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }

    if (this.etapa == 2) {
      if (this.codigoact == '') {
        const codnotnull = this.dialog.open(AlertaSimplesDialog, {
          data: { textoAlerta: "Por favor digite o código para continuar" }
        });
        return;
      }
      else {
        //faz a chamada para validar o código
        this.hideLoginLoad = false;
        //var dadosCodCliente = "idcliente=" + this.uidCliente + "&codigo=" + this.codigoact;

        let customParams = {
          codigo: this.codigoact.replace("-", ""),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
        };
        this.tmaService.confirmarCodigoCadastro(customParams).subscribe((result) => {
          this.hideLoginLoad = true;
          if (result !== []) {
            if (result['res'] == 'done') {
              localStorage["tmsDadosCliente"] = JSON.stringify({ nome: this.tmaService.hcNome, email: this.tmaService.hcEmail, senha: this.tmaService.hcSenha });
              this.router.navigate(['/meu-cadastro/s/3/' + this.uidCliente + '/0']);
            }
            else{
              if (result['res'] == 'incorrect') {
                const codigoInvalido = this.dialog.open(AlertaSimplesDialog, {
                  data: { textoAlerta: "Código digitado está incorreto!" }
                });
                //chamar função que exibe novamente o alerta input
                return;
              }
  
              if (result['res'] == 'invalid') {
                const codigoInvalido = this.dialog.open(AlertaSimplesDialog, {
                  data: { textoAlerta: "Ocorreu um erro. Tente novamente" , iconAlerta: 'warning' }
                });
                //chamar função que exibe novamente o alerta input
                return;
              }
            }
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          });
      }
    }

    if (this.etapa == 3) {
      if (this.ufSelecionadoN == '' || this.cidadeSelecionadaN == '') {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor informe seu estado e a sua cidade para continuar", iconAlerta: 'warning' }
        });
      }
      else {
        let customParams = {
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          uf: this.ufSelecionadoN,
          cidade: this.cidadeSelecionadaN
        };

        this.hideLoginLoad = false;
        this.tmaService.salvarUserLocal(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'done') {
            //proxima etapa
            this.router.navigate(['/meu-cadastro/s/4/' + this.uidCliente + '/0']);
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })
      }


    }

    if (this.etapa == 4) {
      if (this.altura == '') {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor insira sua altura para continuar", iconAlerta: 'warning' }
        });
        return;
      }

      if (this.peso == '') {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor insira seu peso para continuar", iconAlerta: 'warning' }
        });
        return;
      }
      if (this.nivelatividade == '') {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor escolha o seu nível de atividade física", iconAlerta: 'warning' }
        });
        return;
      }

      let customParams = {
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        pesoatual: this.peso.toString().replace('.', ',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
        //altura: this.altura.replace('.', ','),
        altura: this.altura.toString().replace('.', '').replace(',','.'),
        nivelpraticante: this.nivelatividade
      };

      this.hideLoginLoad = false;
      this.tmaService.salvarUserFisic(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'done') {
          //proxima etapa
          this.router.navigate(['/meu-cadastro/s/5/' + this.uidCliente + '/0']);
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
          });
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }
    if (this.etapa == 5) {

      if (this.fotodepois) {
        //
        this.hideLoginLoad = false;
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          fotoBase: encodeURI(this.croppedImage),
          fotonotnow: this.fotodepois
        };
        this.tmaService.salvarUserFotoP(customParams)
          .subscribe((qRes) => {
            this.hideLoginLoad = true;
            if (qRes['res'] == 'done') {
              //go proxima etapa
              this.tmaService.hcFoto = 'default_profile_picture.jpg';
              this.router.navigate(['/meu-cadastro/s/6/' + this.uidCliente + '/0']);
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
      }
      else {
        if (this.croppedImage == '') {
          const notEmptyallowerdd = this.dialog.open(AlertaSimplesDialog, {
            width: '300px',
            data: { tituloAlerta: "Aviso", textoAlerta: "Por favor insira uma foto para continuar, se não deseja adicionar foto, marque a opção <b>Sem Foto</b> ", textoConfirm: "Ok" }
          });
          return;
        }
        else {
          //enviar para servidor 
          this.hideLoginLoad = false;
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            fotoBase: encodeURI(this.croppedImage),
            fotonotnow: false
          };
          //var meusDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&fotobase=' + this.croppedImage;
          this.tmaService.salvarUserFotoP(customParams)
            .subscribe((qRes) => {
              this.hideLoginLoad = true;
              if (qRes['res'] == 'done') {
                //go proxima etapa
                this.tmaService.hcFoto = qRes['fotoF'];
                this.router.navigate(['/meu-cadastro/s/6/' + this.uidCliente + '/0']);
              }
              else {
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                  disableClose: true,
                  data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
                });
              }
            },
              (error) => {
                this.hideLoginLoad = true;
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                  disableClose: true,
                  data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
                });
              })
        }
      }

    }

    if (this.etapa == 6) {
      if (this.nickUsuario == '') {
        const alertaNickV = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor insira um nome de usuário para continuar", iconAlerta: 'warning' }
        });
      }
      else {
        let re = /\./gi;
        var nickReplace = this.nickUsuario.replace(/ /g, '').replace(/\//g, '').replace(/\,/g, '').replace(/\;/g, '');
        this.nickUsuario = nickReplace;
        this.hideLoginLoad = false;
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          meuNick: nickReplace
        };
        this.tmaService.salvarUserNick(customParams)
          .subscribe((qRes) => {
            this.hideLoginLoad = true;
            if (qRes['res'] == 'done') {
              //go proxima etapa
              this.tmaService.hcNomeUsuario = this.nickUsuario;
              this.router.navigate(['/meu-cadastro/s/7/' + this.uidCliente + '/0']);
            }
            if (qRes['res'] == 'chars') {
              const nickInv = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Você inseriu caracteres não permitidos! Por favor insira apenas letras, números e caracteres permitidos (underline, hífen e ponto)", iconAlerta: 'warning' }
              });
            }
            if (qRes['res'] == 'already') {
              const nickAlready = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Este nome de usuário já está em uso. Considere adicionar um número ou outra letra para personalizá-lo e tente novamente", iconAlerta: 'warning' }
              });
            }
            // else {
            //   const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            //     disableClose: true,
            //     data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
            //   });
            // }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
      }
    }

    if (this.etapa == 7) {
      if (this.qTema == '') {
        const erroTema = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Escolha um dos temas disponíveis e clique em continuar", iconAlerta: 'warning' }
        });
      }
      else {
        console.log(this.qTema);
        this.hideLoginLoad = false;
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          meuviewmodel: this.qTema
        };
        this.tmaService.salvarUserTema(customParams)
          .subscribe((qRes) => {
            this.hideLoginLoad = true;
            if (qRes['res'] == 'done') {
              //go proxima etapa
              //talvez uma mensagem exibindo que o cadastro foi completado com sucesso e tal
              this.router.navigate(['/meu-cadastro/s/8/' + this.uidCliente + '/0']);
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro ao salvar as informações. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
      }
    }

    if (this.etapa == 8) {
      this.tmaService.hcEtapa = 8;
      this.router.navigate(['/home']);
    }

  }




  resendCod(): void {
    //enviar codigo again
    const dialogRecebeuCodigo = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: { textoAlerta: "Você recebeu o código de ativação?", textoCancel: "Não, me envie novamente", textoConfirm: "Sim, recebi o código!" }
    });
    dialogRecebeuCodigo.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == true) {
        //recebeu o codigo, digitar, foco
        if(this.etapa == 2){
          this.codigoInput.nativeElement.focus();
        }
        if(this.etapa == 1){
          this.codigoInput1.nativeElement.focus();
        }
        

      }
      else {
        //chamar reenvio
        this.enviarCodigoAct();
      }
    })
  }

  enviarCodigoAct(): void {
    //chamar server para enviar
    this.hideLoginLoad = false;
    let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail
    };
    this.tmaService.goResendCode(customParams)
    .subscribe((qRes) => {
        this.hideLoginLoad = true;
        if (qRes['res'] == 'invalid') {
            const algoErrado3 = this.dialog.open(AlertaSimplesDialog, {
                width: '250px',
                data: { textoAlerta: "E-mail não encontrado no sistema!" }
            });
        }
        else if (qRes['res'] == 'ok') {
            const recDone = this.dialog.open(AlertaSimplesDialog, {
                width: '250px',
                data: { textoAlerta: "Em instantes você receberá um e-mail com o código para ativar seu cadastro" }
            });
        }
        else{
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
        }
    },
        (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
        })

  }


  validarCod(): void {
    //validacao
    if (this.codigoact == '') {
      const codnotnull = this.dialog.open(AlertaSimplesDialog, {
        data: { textoAlerta: "Por favor digite o código para continuar" }
      });
    }
    else {
      //faz a chamada para validar o código
      this.hideLoginLoad = false;
      var dadosCodCliente = "idcliente=" + this.uidCliente + "&codigo=" + this.codigoact;
      this.tmaService.confirmarCodigoCadastro(dadosCodCliente).subscribe((result) => {
        this.hideLoginLoad = true;
        if (result !== []) {
          if (result['res'] == 'invalid') {
            const codigoInvalido = this.dialog.open(AlertaSimplesDialog, {
              data: { textoAlerta: "Código digitado está incorreto!" }
            });
            //chamar função que exibe novamente o alerta input
            return;
          }
          else {
            //cadastro confirmado, salvar dados e redirecionar
            //localStorage["tmsDadosCliente"] = JSON.stringify({ nome: result['nome'], email: result['email'], senha: result['senha'], tipocadastro: result['senha'] });
            if (this.tmaService.paginaAnterior !== '') {
              this.router.navigate([this.tmaService.paginaAnterior]);
            }
            else {
              this.router.navigate(['home/1']);
            }
          }
        }

      })
    }

  }


  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    if (this.imageChangedEvent.target.files.length == 0) {
      this.croppedImage = '';
      console.log("just clear");
      //this.showTools = false;
    }
    else {
      console.log("teste");
      //this.showTools = true;
      this.hideLoginLoad = false;
      // setTimeout(() => {
      //   this.savePic.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // }, 200);
    }

  }

  rotacionarImg() :void{
    console.log("girando");
    this.canvasRotation--;
    
    this.hideLoginLoad = false;
    setTimeout(() => {
      this.hideLoginLoad = true;
    }, 1500);
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    console.log(this.croppedImage);
  }
  imageLoaded() {
    console.log("foiiiiiiiii");
    //this.savePic.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // show cropper
  }
  cropperReady() {
    // cropper ready
    this.hideLoginLoad = true;
  }
  loadImageFailed() {
    // show message
    console.log("failed");
    this.hideLoginLoad = true;
  }

  uploadFile($event) {
    console.log($event.target.files[0]); // outputs the first file
    this.nomeArquivo = $event.target.files[0].name;
  }


  voltar(): void {
    this.router.navigate(['/login']);
  }
}
